__turbopack_context__.v({
  "card": "PdpSimilarListingCard-module__JO0wZq__card",
  "cardLink": "PdpSimilarListingCard-module__JO0wZq__cardLink",
  "glassButton": "PdpSimilarListingCard-module__JO0wZq__glassButton",
});
